/**
 * Shared collision-resistant ID generator.
 *
 * Used by teacher-portal assignment IDs (homework, practice, assessments) to
 * replace per-file ad-hoc generators. NOT for security-sensitive IDs — those
 * should use `crypto.getRandomValues` (see `accounts/logic/classrooms.ts`).
 *
 * Format: `${prefix}_${base36-timestamp}_${6-char base36 random}`
 *
 * Replaces (per Wave 6.4.3 of the Teacher Portal refactor plan):
 *  - HomeworkPage.tsx local genId
 *  - CreateAssessmentPanel.tsx `assignment_${Date.now()}` (collision-prone)
 *  - CreatePracticePanel.tsx `practice_${Date.now()}` (collision-prone)
 */
export function genId(prefix: string): string {
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`
}
